import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
  .highcharts-crosshair {
    fill: ${colors.black};
  }

  .highcharts-legend-item .highcharts-graph {
    stroke-width: 3px;
  }

  .highcharts-xaxis-labels text {
    font-size: 13px;
    font-weight: 700;
    fill: ${colors.grey3};
  }

  .highcharts-yaxis-labels text {
    font-size: 11px;
    fill: ${colors.grey5};
    font-weight: normal;
  }

  .line-chart {
    .highcharts-crosshair,
    .highcharts-crosshair-thin,
    .highcharts-xaxis-category {
      stroke: ${colors.black};
      stroke-width: 1px;
      fill-opacity: 1;
      stroke-opacity: 1;
    }

    .highcharts-color-0 {
      fill: #ff600f; // colors.darkOrange not yet merged
      background-color: #ff600f;
      stroke: #ff600f;
    }

    .highcharts-color-1 {
      fill: #adafb2; // colors.mediumGrey not yet merged
      background-color: #adafb2;
      stroke: #adafb2;
    }

    .line-chart-yaxis-crosshair {
      stroke: ${colors.black};
      stroke-width: 1px;
      fill-opacity: 1;
      stroke-opacity: 1;
    }

    .highcharts-markers path {
      fill: ${colors.white};
    }

    .highcharts-markers path:nth-child(2) {
      stroke-width: 3px;
    }

    .highcharts-graph {
      stroke-width: 3px;
    }
  }
`;

export const TooltipContainer = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  margin: 0;
`;

export const TooltipColor = styled.span<{ colorIndex: number }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  border-radius: 100%;
  background-color: ${(props) =>
    props.colorIndex === 0 ? '#9DAFE7' : '#4B6ACE'};
`;

export const TooltipItem = styled.li`
  display: flex;
  width: 100%;
  margin-bottom: 8px;
  align-items: center;
`;

export const TooltipItemName = styled.span`
  font-size: 11px;
  text-transform: capitalize;
`;

export const TooltipItemValue = styled.strong`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: ${colors.grey8};
  font-weight: 500;
`;

export const TooltipItemLabel = styled.span`
  width: 95px;
  font-size: 11px;
  font-weight: 300;
  color: ${colors.grey5};
`;

export const TooltipItemTrend = styled.span<{ up?: boolean }>`
  width: 24px;
  height: 24px;
  border: 0;
  margin-left: -9px;
  transform: rotate(${(props) => (props.up ? 270 : 90)}deg);
  path {
    stroke-width: 0px;
  }
`;
